/**
  * Usage: dateString | localDate:'format'
 **/

import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { SessionService } from '../services1/session.service';

@Pipe({
    name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {

    constructor(private session: SessionService) { }

    transform(value: any) {

        if (!value) { return ''; }
        let format = 'mediumDate';
        let utcDate = new Date(value);
        let utcString = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(),
                                 utcDate.getUTCHours(), utcDate.getUTCMinutes(), utcDate.getUTCSeconds()).toISOString();

        return formatDate(utcString, format, 'en-US'); // Force UTC formatting
        // return formatDate(value, format, this.session.locale);
    }
}